import components from './components'
import computed from './computed'
import data from './data'
import methods from './methods'
import validations from './validations'
import mounted from './mounted'

export default {
  components,
  computed,
  data,
  methods,
  validations,
  mounted,
  resourcePath: '/v1/patient/settings/profiles'
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/resources/index.js